
export default {
  name: 'sgh-back-to-top',
  props: {
    backToTopTitle: {
      type: String,
      default: 'go up',
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      window.scrollY > 0 ? (this.isVisible = true) : (this.isVisible = false)
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
